import React, { useState, useRef, Fragment, useEffect, useContext } from 'react'
import StepWizard from 'react-step-wizard';
import globalStates from '../../../../../context/globalStates';
import useRequest from '../../../../../hooks/useRequest';
const QuizStepUygunluk = require('../../../../../sources/Step1Q.json')
const QuizStepYerindelik = require('../../../../../sources/Step1QPortfoy.json')
const SelectiveStep = require('../../../../../sources/Step2Q.json')

const EpisodeOne = (props) => {
    const { innerTexts } = useContext(globalStates)

    const [answers, setAnswers] = useState([])
    const [danger, setDanger] = useState(false)
    const [dangerInput, setDangerInput] = useState(true)
    const [dangerText, setDangerText] = useState(false)
    const [notAllowed, setNotAllowed] = useState(false)

    const { startFetch, response, loading } = useRequest()

    const [yerindelikTextAnswer, setYerindelikTextAnswer] = useState()

    const [activeClass] = useState(["card active-card", "card none"])
    const [btnActiveClass] = useState(["btn btn-secondary active-card", "btn none"])

    const [getFunctions, setGetFunctions] = useState({})
    const [activeStep, setActiveStep] = useState(1)

    const refInput = useRef([])
    const refSelectiveInput = useRef([])

    const [puan, setPuan] = useState(0)
    const [letter, setLetter] = useState("-")
    const QuizStep = innerTexts.yerindelik ? QuizStepYerindelik : QuizStepUygunluk
    useEffect(() => {
        if (response) {
            if (response.errNo === 0) {
                if (response.bilgiler) {
                    for (let index = 0; index < QuizStep.length; index++) {
                        const element = QuizStep[index];
                        for (var x in element) {
                            for (var y in response.bilgiler) {
                                if (element[x] === y) {
                                    for (let key = 0; key < element.options.length; key++) {
                                        const data = element.options[key];
                                        if (data.value === response.bilgiler[y]) {
                                            if (element.question.startsWith("Kredi borcu") || element.question.startsWith("Meslek")) {
                                                return;
                                            }
                                            handleAnswers(key, element, index);
                                        }
                                    }

                                }
                            }

                        }
                        setPuan(response.bilgiler.puan)
                        setLetter(response.bilgiler.harf)

                    }
                    for (let index = 0; index < SelectiveStep.length; index++) {
                        const element = SelectiveStep[index];
                        for (let fieldIndex = 0; fieldIndex < element.fields.length; fieldIndex++) {
                            const fieldElement = element.fields[fieldIndex];
                            for (var x in fieldElement) {
                                for (var y in response.bilgiler) {
                                    if (fieldElement[x] === y) {
                                        for (let key = 0; key < fieldElement.buttons.length; key++) {
                                            const data = fieldElement.buttons[key];
                                            if (data.value === response.bilgiler[y]) {
                                                handleSelectiveAnswers(element, index, fieldElement, fieldIndex, data, key)
                                            }
                                        }

                                    }
                                }
                            }

                        }
                    }
                }
                else {
                    if (activeStep === getFunctions.totalSteps) {
                        setDanger(false)
                        props.handleProgress(props.handleWizard.currentStep + 1)
                        props.handleWizard.nextStep()
                    } else {
                        setDanger(false)
                        getFunctions.nextStep()
                    }
                }
            }
        }
    }, [response])

    useEffect(() => {

        startFetch("islem=uygunluk_testi_getir&step=2", "GET")

    }, [activeStep === getFunctions.totalSteps])

    const Step1Q = (props) => {

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div style={{ textAlign: "center", color: "#898989" }} className="card-body">
                                <h2>{innerTexts.label_step_one_episode_title}</h2>
                                <p>{innerTexts.label_step_one_episode_description}</p>
                                <p><strong>{innerTexts.label_step_one_episode_warning}</strong></p>
                                <button
                                    onClick={() => { props.goToStep(2); setGetFunctions(props) }}
                                    disabled={loading}
                                    style={{ width: "70%", filter: loading ? "brightness(120%)" : "", cursor: loading ? "no-drop" : "pointer" }}
                                    className="btn  btn-primary btn-lg"
                                >
                                    {loading ? "Yükleniyor..." : innerTexts.btn_text_step_one_episode}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const handleAnswers = async (key, item, i, x) => {
        x?.text === "Var" && x?.value <= 0 ? setDangerInput(true) : setDangerInput(false)

        refInput.current[i][key].className = activeClass[0]
        var model = {
            [item.field]: item.options[key].value,
            bolum: item.bolum,
            islem: item.islem,
            step: item.step,
            puan: item.options[key].puan,
        }
        if (x && x.value && !x.textInput && x.input) {
            model.mali_yukumluluk_tutar = x.value;
        }
        if (x && x.value && x.textInput) {
            model[item.field] = x.value;
        }
        answers[item.question] = model
        setAnswers(answers)
        for (let index = 0; index < item.options.length; index++) {
            if (index !== key) {
                try {
                    refInput.current[i][index].className = activeClass[1]
                } catch (error) {
                    console.log(index, key, i, refInput.current[i], item, "error")
                }

            }
        }
    }


    const handleSelectiveAnswers = (item, itemIndex, field, fieldIndex, btn, btnIndex) => {
        refSelectiveInput.current[itemIndex][fieldIndex][btnIndex].className = btnActiveClass[0]
        var model = {
            [item.fields[fieldIndex].field]: item.fields[fieldIndex].buttons[btnIndex].value,
            bolum: item.bolum,
            islem: item.islem,
            step: item.step,
            puan1: item.fields[fieldIndex].buttons[btnIndex].puan
        }
        answers[item.question] = {
            ...answers[item.question],
            ...model
        }
        setAnswers(answers)
        for (let index = 0; index < item.fields[fieldIndex].buttons.length; index++) {
            if (index !== btnIndex) {
                refSelectiveInput.current[itemIndex][fieldIndex][index].className = btnActiveClass[1]
            }
        }
    }

    const SendAnswer = (item) => {
        if (answers[item.question]) {
            var model = answers[item.question]
            var params = ""
            for (var I in model) {
                params += '' + I + '=' + model[I] + '&'
            }
            return startFetch(params, "POST")
        }
        setDanger(true)
    }

    const SendSelectiveAnswer = (item) => {
        if (item.fields.length === ValidateSelective(item)) {
            var model = answers[item.question]
            var params = ""
            for (var I in model) {
                params += '' + I + '=' + model[I] + '&'
            }
            setDanger(false)
            return startFetch(params, "POST")
        }

        setDanger(true)

    }
    const ValidateSelective = (item) => {
        var count = 0
        for (var x in answers[item.question]) {
            for (let index = 0; index < item.fields.length; index++) {
                const element = item.fields[index];
                if (element.field === x) {
                    count++
                }
            }
        }
        return count
    }
    const QuizStepRender = (item, index) => {

        var model = {};
        const renderOptions = (x, k) => {

            return (
                <Fragment key={k}>
                    <div key={k} className="col-md-12">
                        <div key={k} ref={r => {
                            model[k] = r
                            refInput.current[index] = model
                        }}
                            onClick={x.disabled ? null : x.textInput ?
                                () => { setNotAllowed(true); handleAnswers(k, item, index, { ...x, value: document.getElementById(`input_${k}`).value }) }
                                :
                                x.input ?
                                    () => { setNotAllowed(true); handleAnswers(k, item, index, { ...x, value: document.getElementById(`input_${k}`).value }) }
                                    :
                                    () => { setNotAllowed(false); handleAnswers(k, item, index, x) }}
                            style={{ cursor: x.disabled ? "not-allowed" : "pointer" }} className="card" style={{ width: "100%" }}>
                            <div style={{ cursor: x.disabled ? "not-allowed" : "pointer", backgroundColor: x.disabled ? "grey" : "inherit" }} className="card-body">
                                <div style={{ cursor: x.disabled ? "not-allowed" : "pointer", display: "flex", justifyContent: "space-between" }} className="form-check">
                                    <label style={{ cursor: x.disabled ? "not-allowed" : "pointer" }} className="form-check-label" htmlFor={x.text}>
                                        {x.text}
                                    </label>
                                    {x.input && <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <input
                                            onChange={(e) => { x.textInput && e.target.value?.length < 2 ? setNotAllowed(true) : x.input && !e.target.value > 0 ? setNotAllowed(true) : setNotAllowed(false); handleAnswers(k, item, index, { ...x, value: document.getElementById(`input_${k}`).value }) }}
                                            type={x.textInput ? 'text' : 'number'}
                                            id={`input_${k}`}
                                            placeholder={x.textInput ? x.text : '0'}
                                            style={{ textAlign: "right", width: "30vw", minWidth: "200px" }}></input>

                                        {!x.textInput && <label htmlFor={`input_${k}`}>TL</label>}
                                    </div>}
                                </div>
                            </div>
                        </div>
                        {x.textInput && dangerText ? <h5 style={{ color: "red", paddingRight: "1vw", textAlign: "right" }}>Zorunlu alanı doldurunuz!</h5>
                            :
                            x.input && dangerInput && <h5 style={{ color: "red", paddingRight: "2vw", textAlign: "right" }}>Geçerli bir rakam giriniz!</h5>}
                    </div>
                </Fragment>
            )
        }

        return (
            <div key={index} style={{ textAlign: "center" }}>
                <h2>{item.question}</h2>
                <div style={{ textAlign: "left" }} className="row">
                    {item.options.map(renderOptions)}

                    <div className="col-md-12">
                        {
                            danger ? <div style={{ marginTop: "5%" }} className="alert alert-danger" role="alert">
                                {innerTexts.error_messages_step_one_episode}
                            </div> : void 0
                        }

                    </div>
                    <div style={{ marginTop: "5%" }} className="row">
                        <div className="col-md-6">
                            <button
                                onClick={() => { getFunctions.previousStep(); }}
                                className="btn  btn-secondr btn-lg btn-block"
                                disabled={loading}
                                style={{ filter: loading ? "brightness(120%)" : "", cursor: loading ? "no-drop" : "pointer" }}
                            >
                                {innerTexts.btn_text_back}
                            </button>
                        </div>
                        <div className="col-md-6">
                            <button
                                onClick={() => { !notAllowed && SendAnswer(item) }}
                                disabled={loading}
                                style={{ filter: loading ? "brightness(120%)" : "", cursor: loading || notAllowed ? "no-drop" : "pointer" }}
                                className="btn  btn-primary btn-lg btn-block"
                            >
                                {loading ? "Yükleniyor..." : innerTexts.btn_text_forward}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

    const SelectiveStepRender = (item, itemIndex) => {
        var fieldModel = {}

        const renderFields = (fieldItem, fieldIndex) => {

            var model = {}
            return (
                <div key={fieldIndex} style={{ cursor: "pointer" }} className="card" style={{ width: "100%" }}>
                    <div className="card-body">
                        <div className="col-md-3 body">
                            <strong>{fieldItem.text + " "}</strong>
                            <br />
                            <span style={{ color: "#797979", fontSize: "smaller" }}>({fieldItem.description})</span>
                        </div>
                        {fieldItem.buttons.map((btn, btnIndex) => {
                            return (
                                <div key={btnIndex} className="col-md-3">
                                    <div style={{ border: "1px solid #4e3a3a80" }} key={fieldIndex} ref={r => {
                                        model[btnIndex] = r
                                        fieldModel[fieldIndex] = model
                                        refSelectiveInput.current[itemIndex] = fieldModel
                                    }} onClick={() => {
                                        handleSelectiveAnswers(item, itemIndex, fieldItem, fieldIndex, btn, btnIndex)
                                    }} className="btn">{btn.text}</div></div>

                            )
                        })}

                    </div>
                </div>
            )
        }

        return (
            <Fragment>
                <div key={itemIndex} style={{ textAlign: "center" }}>
                    <h2>{item.question}</h2>
                    <div style={{ textAlign: "left" }} className="row">
                        {
                            item.fields.map(renderFields)
                        }
                        <div style={{ marginTop: "5%" }} className="row">
                            <div className="col-md-6">
                                <button
                                    onClick={() => { getFunctions.previousStep(); }}
                                    className="btn  btn-secondr btn-lg btn-block"
                                    disabled={loading}
                                    style={{ filter: loading ? "brightness(120%)" : "", cursor: loading ? "no-drop" : "pointer" }}
                                >
                                    Geri
                                </button>
                            </div>
                            <div className="col-md-6">
                                <button
                                    onClick={() => { SendSelectiveAnswer(item) }}
                                    className="btn  btn-primary btn-lg btn-block"
                                    disabled={loading}
                                    style={{ filter: loading ? "brightness(120%)" : "", cursor: loading ? "no-drop" : "pointer" }}
                                >
                                    İleri
                                </button>
                            </div>
                            <div className="col-md-12">
                                {
                                    danger ? <div style={{ marginTop: "5%" }} className="alert alert-danger" role="alert">
                                        {innerTexts.error_messages_step_one_episode}
                                    </div> : void 0
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
    const ResultRender = () => {


        return (
            <div key={""} style={{ textAlign: "center" }}>
                <h2></h2>
                <div style={{ textAlign: "left" }} className="row">
                    <div className="alert alert-info" role="alert">
                        <h2 className="alert-heading">Puan: <span style={{ color: "green" }}> {puan} </span></h2>
                        <h4>{innerTexts.label_step_one_episode_result_title}: {letter}</h4>
                        <hr />
                        <p className="mb-0">{innerTexts.label_step_one_episode_result_description}</p><br />
                        <table className="table table-Result table-bordered table-condensed">
                            <thead>
                                <tr>
                                    <th scope="col-6">Risk ve Getiri Grubu</th>
                                    <th scope="col-6">Açıklama</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center">A</td>
                                    <td>Çok Düşük Riskli (Repo-Ters Repo, BPP, Yatırımcı bilgi formunda risk değeri 1 olan yatırım fonları vb.)</td>
                                </tr>
                                <tr>
                                    <td className="text-center">B</td>
                                    <td>Düşük Riskli (Hazine Bonosu, Devlet Tahvili, Hazine Kira Sertifikaları, Yatırımcı bilgi formunda risk değeri 2 ve 3 olan yatırım fonları  vb.)</td>
                                </tr>
                                <tr>
                                    <td className="text-center">C</td>
                                    <td>Orta Riskli (Hisse senedi, Hisse Senedi Fonları, Borsa Yatırım Fonları, Eurobond, Dövizli Tahviller, Özel Sektör Borçlanma Araçları, Kira Sertifikaları, Yabancı Menkul Kıymetler Fonu, Kıymetli Madenler Fonu, Kira ve Darphane Sertifikaları vb.)</td>
                                </tr>
                                <tr>
                                    <td className="text-center">D</td>
                                    <td>Yüksek Riskli (Türev İşlemler (Vadeli İşlem ve Opsiyon Piyasasında), Varant, Yatırım Kuruluşu Sertifikası, Yatırımcı bilgi formunda risk değeri 5 ve 6 olan yatırım fonları vb. vb.)</td>
                                </tr>
                                <tr>
                                    <td className="text-center">E</td>
                                    <td>Çok Yüksek Riskli (Tezgahüstü Türev İşlemler, Yapılandırılmış Borçlanma Araçları, Kaldıraçlı Alım Satım İşlemleri - FX, Yatırımcı bilgi formunda risk değeri 7 olan yatırım fonları  vb.)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ marginTop: "5%" }} className="row">
                    <div className="col-md-6">
                        <button
                            onClick={() => { getFunctions.previousStep(); }}
                            className="btn  btn-secondr btn-lg btn-block"
                            disabled={loading}
                            style={{ filter: loading ? "brightness(120%)" : "", cursor: loading ? "no-drop" : "pointer" }}
                        >
                            {innerTexts.btn_text_back}
                        </button>
                    </div>
                    <div className="col-md-6">
                        <button
                            onClick={() => {
                                setDanger(false)
                                props.handleWizard.nextStep()
                            }}
                            className="btn  btn-primary btn-lg btn-block"
                            disabled={loading}
                            style={{ filter: loading ? "brightness(120%)" : "", cursor: loading ? "no-drop" : "pointer" }}
                        >
                            {loading ? "Yükleniyor..." : innerTexts.btn_text_forward}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <StepWizard onStepChange={steps => { setActiveStep(steps.activeStep) }}>
            <Step1Q />
            {QuizStep.map(QuizStepRender)}
            {SelectiveStep.map(SelectiveStepRender)}
            <ResultRender />
        </StepWizard>
    )
}
export default EpisodeOne
